<template>

    <div class="step-content infos">
        <div class="intro-block">
            <h5 class="txt-grt">Your informations</h5>
            <p>To be sure we will send you the right information in the right place, please provide your data.</p>
        </div>
        <div class="step-inner-content">
            <InputWrapper placeholder="Name" v-model="Global.mockupConfig.infos.name" :max-chars="15"></InputWrapper>
            <InputWrapper placeholder="Company" v-model="Global.mockupConfig.infos.company" :max-chars="15"></InputWrapper>
            <InputWrapper placeholder="Email" v-model="Global.mockupConfig.infos.email"></InputWrapper>
            <div class="nxt-out">
                <div class="bgout"></div>
                <div></div>
                <router-link tag="div" to="/content" class="btn main txt-blk">
                    <span class="hvr"></span>
                    <span class="txt">Continue</span>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import InputWrapper from '../../components/InputWrapper'

    export default {

        name: 'A',

        components: {
            InputWrapper
        },

        data() {
            return {
                Global
            }
        }
    }

</script>